import { getApiClient } from "./ApiClient.js";


/**
 * Gibt alle Krankenkassen zurück.
 * @returns {Promise<*>}
 */
export function getKrankenkassen() {
    const client = getApiClient();
    return client.get('/api/gkv/name');
}
